const NAMESPACE = "addressSubElementLayout";

const KEYS = {
    newContactOptionLabel: "newContactOptionLabel",
    addressSubLabel: "addressSubLabel",
    addressLineTwoAltLabel: "addressLineTwoAltLabel",
    streetPlaceholder: "streetPlaceholder",
    cityPlaceholder: "cityPlaceholder",
    unitedStatesGroupLabel: "unitedStatesGroupLabel",
    canadaGroupLabel: "canadaGroupLabel",
    zipCodePlaceholder: "zipCodePlaceholder",
    countySubLabel: "countySubLabel",
    stateAltLabel: "stateAltLabel",
    selectPrompt: "selectPrompt",
    sameAsDropdownAltLabel: "sameAsDropdownAltLabel"
};

const MESSAGES = {
    [KEYS.newContactOptionLabel]: {
        value: "New Contact",
        comment: "Default value for same-as selector, which requires entering new information."
    },
    [KEYS.addressSubLabel]: {
        value: "Address",
        comment: "Label for address field"
    },
    [KEYS.addressLineTwoAltLabel]: {
        value: "Address line 2",
        comment: "Alt label for address line 2"
    },
    [KEYS.streetPlaceholder]: {
        value: "Street",
        comment: "Placeholder for street address input"
    },
    [KEYS.cityPlaceholder]: {
        value: "City",
        comment: "Placeholder for city name input"
    },
    [KEYS.unitedStatesGroupLabel]: {
        value: "United States",
        comment: "Label for group of US state postal abbreviations"
    },
    [KEYS.canadaGroupLabel]: {
        value: "Canada",
        comment: "Label for group of Canadian province postal abbreviations"
    },
    [KEYS.zipCodePlaceholder]: {
        value: "Zip Code",
        comment: "Placeholder for zip code input"
    },
    [KEYS.countySubLabel]: {
        value: "County",
        comment: "Label for county name selector"
    },
    [KEYS.stateAltLabel]: {
        value: "State",
        comment: "Alt label for state drop down"
    },
    [KEYS.selectPrompt]: {
        value: "Please select...",
        comment: "Selection prompt for county selector"
    },
    [KEYS.sameAsDropdownAltLabel]: {
        value: "Existing contact to use for this contact",
        comment:
            "Alt label for the selector that allows selecting an existing contact to use for this contact instead of specifying new contact information"
    }
};

export { KEYS, NAMESPACE, MESSAGES };
